<template>
      <div class="pano" id="pano" style="width:100%; height:500px;"></div>
</template>
<script>
import mapSettings from '../../lib/map';
import svg from '../../lib/svg';

export default {
  name: 'Business Profile',
  props: ['lat','lng','lid'],
  data() {
    return {
      title: "Mapping System",
    }
  },
  mounted(){
    this.loadMap();
  },
methods:{   
    loadMap(){
        
        this.map = new google.maps.Map(document.getElementById('pano'), {
            zoom: 18,
            center: new google.maps.LatLng(this.lat, this.lng),
        });
        
        var fenway = {lat:32.9373599, lng: -96.8237044};
         var panorama = new google.maps.StreetViewPanorama(
          document.getElementById('pano'), {
            position: new google.maps.LatLng(32.9373599, -96.8237044),
            pov: {
              heading: 1,
              pitch: 1
            }
          });

        this.map.setStreetView(panorama);
    }
 }
}
</script>





// WEBPACK FOOTER //
// src/components/mapping/business-profile-panorama.vue